import { FC } from 'react';
import AirplaneIcon from '@/assets/Icons/Spotnana-Flight-Fill.svg?react';
import HotelStayIcon from '@/assets/Icons/Hotel-Stay.svg?react';
import styles from './TripEmissionLog.module.scss';
import DataComplianceMissingType = App.Enums.DataComplianceMissingType;

interface MissingFlagProps {
	missingItem: DataComplianceMissingType;
}

const MissingFlag: FC<MissingFlagProps> = ({ missingItem }) => {
	const isMissingAccommodation = missingItem === 'missing-hotel';

	return (
		<div className={styles.missingFlagDataTable}>
			{isMissingAccommodation ? (
				<HotelStayIcon aria-hidden="true" />
			) : (
				<AirplaneIcon aria-hidden="true" />
			)}
			<span>{isMissingAccommodation ? 'Accommodation' : 'Transport'}</span>
		</div>
	);
};

export default MissingFlag;
